import { useTheme } from '../useTheme';
export const useGetBorderRadius = () => {
  const {
    isTrellisLight
  } = useTheme();
  return isTrellisLight ? 'border-radius-lg' : '0';
};